export default __webpack_public_path__ + "static/media/avatar_dog7.d5c1e27b.mp3";